import axios from "axios";
import { parseString } from "xml2js";

const HEADERS = {
  headers: {
    "Access-Control-Allow-Origin": "*"
  }
};

const BASE_URL = "http://assets.baytelman.com.s3.amazonaws.com/";
const YOUTUBE_EXTENSION = "youtube";
const SUPPORTED_FILES = ["jpg", "jpeg", "png", "mp4", YOUTUBE_EXTENSION];
const THUMB_EXTENSION = "_thumbnail";

const getFileExtension = filename => {
  return filename
    .toLowerCase()
    .split(".")
    .pop();
};

const getFileBaseName = filename => {
  const parts = filename.split(".");
  parts.pop();

  return parts.join(".");
};

const getYouTubeId = filename => {
  if (filename.indexOf(YOUTUBE_EXTENSION) === -1) {
    return false;
  }
  const parts = filename
    .split("/")
    .pop()
    .split(".");
    parts.pop();
    return parts.pop();
};
const getYouTubeThumbnail = filename => {
  return `//img.youtube.com/vi/${getYouTubeId(filename)}/mqdefault.jpg`
}

const getThumbnailBaseName = filename =>
  filename.substring(0, filename.indexOf(THUMB_EXTENSION));

const shouldList = key =>
  key.indexOf(THUMB_EXTENSION) === -1 &&
  SUPPORTED_FILES.indexOf(getFileExtension(key)) !== -1;

const getThumbnailDirectory = files => {
  const directory = {};
  files
    .filter(key => key.indexOf(THUMB_EXTENSION) !== -1)
    .forEach(key => (directory[getThumbnailBaseName(key)] = key));
  return directory;
};

const getDimensions = key => {
  const parts = getFileBaseName(key).split("_");
  return {
    width: parts[2],
    height: parts[3]
  };
};

export const getFilesWithPrefix = async prefix => {
  try {
    const res = await axios.get(BASE_URL + "?prefix=" + prefix, HEADERS);

    const result = await new Promise((resolve, reject) => {
      parseString(res.data, (err, result) => {
        if (err) {
          return reject(err);
        }
        return resolve(result);
      });
    });
    const content = result.ListBucketResult.Contents;
    const allFiles = content
      .map(({ Key }) => Key[0])
      .filter(key => SUPPORTED_FILES.indexOf(getFileExtension(key)) !== -1);

    const thumbnailsDictionary = getThumbnailDirectory(allFiles);

    const movieTags = [{ value: "mov", title: "mov" }];
    const images = allFiles
      .filter(shouldList)
      .sort()
      .map(key => {
        const thumb = thumbnailsDictionary[getFileBaseName(key)];
        const dimensions = !getYouTubeId(key) && getDimensions(thumb);

        return {
          key: key,
          src: getYouTubeId(key) ? getYouTubeId(key) : BASE_URL + key,
          thumbnail: getYouTubeId(key)
            ? getYouTubeThumbnail(key)
            : thumb && BASE_URL + thumb,
          thumbnailWidth: getYouTubeId(key)
            ? 2
            : dimensions && 1 * dimensions.width,
          thumbnailHeight: getYouTubeId(key)
            ? 1
            : dimensions && 1 * dimensions.height,
          tags: getYouTubeId(key) ? movieTags : [],
          type: getYouTubeId(key) ? "video" : "image"
        };
      });
    return images;
  } catch (e) {
    throw e;
  }
};



// WEBPACK FOOTER //
// ./src/GalleryImport.js